import { api } from "./api";


export const dayWiseAttendanceList = async (addUrl = "") => {
  return await api.get(`bus/student/attendance/list?${addUrl}`);
};
